import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { TagEditForm } from "./components/TagEditForm";

export function EditTagPage() {
  return (
    <LqsPage title="Edit Tag">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <TagEditForm />
      </Container>
    </LqsPage>
  );
}
